import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type BeneficiaryTypeGrantsSaveFailedAction = {
	type: 'BENEFICIARY_TYPE_GRANTS_SAVE_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): BeneficiaryTypeGrantsSaveFailedAction => ({
	type: 'BENEFICIARY_TYPE_GRANTS_SAVE_FAILED',
	payload,
});
